module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1074.f9cdddc9.jpg";